(function() { window.GUID_9d85656f_fd1b_4a4d_94f5_60d4181c3f5b = { getGuid: function() { return "9d85656f-fd1b-4a4d-94f5-60d4181c3f5b"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PersonaDropdownPickerFormat;
        (function (PersonaDropdownPickerFormat) {
            PersonaDropdownPickerFormat[PersonaDropdownPickerFormat["Large"] = 0] = "Large";
            PersonaDropdownPickerFormat[PersonaDropdownPickerFormat["Small"] = 1] = "Small";
            PersonaDropdownPickerFormat[PersonaDropdownPickerFormat["PageHeader"] = 2] = "PageHeader";
        })(PersonaDropdownPickerFormat = Enumeration.PersonaDropdownPickerFormat || (Enumeration.PersonaDropdownPickerFormat = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PersonaDropdownPickerFormat.pre.js.map
